function initSlick() {
    if($(window).width() > 767){
        if($('.my-slick-slider-container').hasClass('desktop-unslick')) {
            $('.arrow-slick-slider').slick('unslick');
            $('.my-slick-slider-container').off('afterChange');
        }
    } else {
        const slickSlider = $('.my-slick-slider-container');
        $(slickSlider).each( function(index, element) {
                if($(element).hasClass('slick-slider-enable')) {
                    $(element).addClass('arrow-slick-slider');
                    $(element).not('.slick-initialized').slick({
                        dots: false,
                        arrows: false,
                        prevArrow: $('.prev-arrow--primary_btn'),
                        nextArrow: $('.next-arrow--primary_btn'),
                        appendArrows: $('.arrow-slick-slider'),
                        infinite: true,
                        speed: 1,
                        slidesToShow: 1,
                        adaptiveHeight: true
                    });
                }
            }
        );
    }
}

function positionArrow() {
    const sliderContainer = document.querySelector('.slider-container-wrapper');
    const slickImage = document.querySelector('.slick-active img');
    const arrowsPrimaryBtn = document.querySelectorAll('.next-arrow--primary_btn, .prev-arrow--primary_btn');
    if(!sliderContainer || !slickImage ) {
        return;
    }
    const wrapperOffset = sliderContainer.getBoundingClientRect().top;
    const imgOffset = slickImage.getBoundingClientRect().top;
    const offset = imgOffset - wrapperOffset;
    $(arrowsPrimaryBtn).css( {
        'top':  offset + ($(slickImage)[0].clientHeight / 2) - 25 + 'px',
        'display': 'block'
    });
}

if($(document).find(".slick-slider-enable").length > 0){
    window.addEventListener('resize', function(event) {
        initSlick()
    }, true);
}

// $(document).ready(function () {
    initSlick();
//     positionArrow();
// });

//  $(window).resize(function(){
//     initSlick();
//     setTimeout(function() {
//         positionArrow();
//     },
//     100);
//  });

// window.addEventListener('shopify:section:load', function(event) {
//     initSlick();
//     positionArrow();
// });